import { NgModule } from "@angular/core";
import { LoginComponent } from "./components/login.component";
import { SharedModule } from "app/shared/shared.module";
import { RouterModule } from "@angular/router";
import { AUTH_ROUTES } from "./auth.routing";
import { AuthService } from "./services/auth.service";
import { ConfirmPasswordComponent } from "./components/confirm-password.component";
import { RecoverPasswordComponent } from "./components/recover-password.component";

@NgModule({
	declarations: [
		LoginComponent,
		ConfirmPasswordComponent,
		RecoverPasswordComponent
	],
	imports: [
		SharedModule,
		RouterModule.forChild(AUTH_ROUTES)
	],
	exports: [
		LoginComponent
	],
	providers: [
		AuthService
	]
})
export class AuthModule {

}
